import backendHttpClient from '@services/_httpClient/backend.http-client';

import type { AssignSmartMatchesDto } from './dtos/assign.dto';
import type { GetSmartMatchInterventionsParams } from './dtos/getInterventions.dto';
import type { SmartMatchRepository } from './repository';
import type {
  AssignSmartMatchesOutput,
  AssignSmartMatchesResponse,
} from './types/assign.type';
import type {
  GetSmartMatchInterventionsOutput,
  GetSmartMatchInterventionsResponse,
} from './types/getInterventions.type';

class SmartMatchService implements SmartMatchRepository {
  public async getInterventions(
    params: GetSmartMatchInterventionsParams,
  ): Promise<GetSmartMatchInterventionsOutput> {
    const { data } = await backendHttpClient.get<
      GetSmartMatchInterventionsResponse,
      GetSmartMatchInterventionsParams
    >({
      path: 'smart-matches/interventions',
      params: {
        serviceRequestId: params.serviceRequestId,
      },
    });

    return { matches: data.matches };
  }

  public async assign(
    payload: AssignSmartMatchesDto,
  ): Promise<AssignSmartMatchesOutput> {
    const { data } = await backendHttpClient.post<
      AssignSmartMatchesResponse,
      AssignSmartMatchesDto
    >({
      path: 'smart-matches/assign',
      body: payload,
    });

    return { assigned: data.assigned, failed: data.failed };
  }
}

export const smartMatchService = new SmartMatchService();
